//
//
//
//
//
//
//

export default {
  methods: {
    handlerService (item) {
      let linkUrl = item.url

      if (+item.fwxsdm === 1) {
        if (+item.sfxtyzdm === 1) { // 配置index.html/#/exam或/exam
          if (linkUrl.indexOf('zs_mngt') >= 0) {
            let url = document.location.protocol + '//' + document.location.host + linkUrl
            window.open(url, '_blank')
          } else if (linkUrl.indexOf('index.html#') >= 0) {
            linkUrl = linkUrl.replace('index.html#', '')
            this.$router.push(linkUrl)
          } else {
            this.$router.push(linkUrl)
          }
        } else { // 绝对地址在新页面打开，相对地址在当前页面打开
          if (linkUrl.indexOf('http') === 0) {
            const a = document.createElement('a')
            a.target = '_blank'
            a.href = linkUrl

            a.click()
          } else {
            window.location = linkUrl
          }
        }
      } else {
        this.$router.push({
          path: '/serviceContent',
          query: { wid: item.wid },
        })
      }
    },
  },
}
